import _ from 'lodash';
import {
   GET_POSTED_APPLICATION_MESSAGE,GET_POSTED_APPLICATION_MESSAGE_SUCCESS,GET_POSTED_APPLICATION_MESSAGE_FAIL
} from "../actions";

const defaultState = {	
	fetchingPostedApplicationMessage: false,
	postedApplicationMessage: '',
	failedToGetPostedApplicationMessage: '',
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case GET_POSTED_APPLICATION_MESSAGE:
			return {
				...state,
				fetchingPostedApplicationMessage: true,
                failedToGetPostedApplicationMessage: '',
			};
		case GET_POSTED_APPLICATION_MESSAGE_SUCCESS:
			if(!action.payload.text) return {...state, fetchingPostedApplicationMessage: false};
			return {
				...state,
				postedApplicationMessage: action.payload.text,
                fetchingPostedApplicationMessage: false,
			};
		case GET_POSTED_APPLICATION_MESSAGE_FAIL:
			const postedApplicationMessageErrorMsg =`Failed to retrieve posted application landing page message.`;
			return {
				...state,
				fetchingPostedApplicationMessage: false,
                failedToGetPostedApplicationMessage: postedApplicationMessageErrorMsg,
			};
		default:
			return state;
	}
}
